import { type RequestPayload, router } from "@inertiajs/core";
import { GlobalDocumentForm } from "../../../components/document/global/GlobalDocumentForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Document } from "../../../models/document";
import type { Group } from "../../../models/group";
import type { YearContext } from "../../../models/yearContext";
import { global_document_path, global_documents_path } from "../../../routes";

type GlobalDocumentEditProps = {
  document: Document;
  year_contexts: YearContext[];
  groups: Group[];
};

export default function GlobalDocumentEdit({ year_contexts, groups, document }: GlobalDocumentEditProps) {
  const { pathWithYearContext } = useYearContext();

  return (
    <ContentShell title={`Globales Dokument ${document.title}`} onBack={() => router.get(pathWithYearContext(global_documents_path))}>
      <GlobalDocumentForm
        document={document}
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Speichern"
        onSubmit={(values: RequestPayload) =>
          router.patch(pathWithYearContext(global_document_path, document.id), values, {
            forceFormData: true,
          })
        }
      />
    </ContentShell>
  );
}
